import { Component } from '@angular/core';
import { FormControl } from '@angular/forms';
import { OkCancelModalDialogComponent } from '@app/shared/popup/ok-cancel/ok-cancel.modal-dialog';

@Component({
  templateUrl: './link-confirmation-modal.component.html',
  standalone: false
})
export class LinkConfirmationModalComponent extends OkCancelModalDialogComponent {
  protected doNotAskAgain = new FormControl(false);
}
